export default __webpack_public_path__ + "static/media/orch-master-log.8419b47a.jpg";